import { Component, OnInit, OnDestroy, Input } from "@angular/core";

import { AlertService, MessageSeverity, DialogType } from '../../services/alert.service';
import { AuthService } from "../../services/auth.service";
import { ConfigurationService } from '../../services/configuration.service';
import { Utilities } from '../../services/utilities';
import { UserLogin } from '../../models/user-login.model';
import { Router } from "@angular/router";
import { MetaService } from "../../services/MetaService";
import { SesaRegisterComponent } from "./sesa-register.component";
import { OrderService } from "../../services/orders.service";
import { LocalStoreManager } from "../../services/local-store-manager.service";
import { FormsModule } from '@angular/forms';
import { CommonModule } from "@angular/common";
import { AnalyticsService } from "../../services/analytics.service";

@Component({
    selector: "app-login",
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    imports: [CommonModule, FormsModule],
    standalone: true
})

export class LoginComponent implements OnInit, OnDestroy {

    userLogin = new UserLogin();
    isLoading = false;
    formResetToggle = true;
    modalClosedCallback: () => void;
    loginStatusSubscription: any;

    @Input()
    isModal = false;


    constructor(private alertService: AlertService, private authService: AuthService, private configurations: ConfigurationService,
        private router: Router, private metaService: MetaService, public orderService: OrderService, private localStorage: LocalStoreManager,
    private analytics: AnalyticsService) {

    }


    ngOnInit() {
        this.analytics.SendEventGa('selection', null, 'Logowanie_Otwarcie formularza', 0);
        document.getElementsByClassName("navbar-collapse")[0].classList.remove('show')
        this.userLogin.rememberMe = this.authService.rememberMe;

        if (this.getShouldRedirect()) {
            this.authService.redirectLoginUser();
        }
        else {
            this.loginStatusSubscription = this.authService.getLoginStatusEvent().subscribe(isLoggedIn => {
                if (this.getShouldRedirect()) {
                    this.authService.redirectLoginUser();
                }
            });
        }
        this.metaService.createCanonicalURL("/");
    }


    ngOnDestroy() {
        if (this.loginStatusSubscription)
            this.loginStatusSubscription.unsubscribe();
    }


    getShouldRedirect() {
        return !this.isModal && this.authService.isLoggedIn && !this.authService.isSessionExpired;
    }


    showErrorAlert(caption: string, message: string) {
        this.alertService.showMessage(caption, message, MessageSeverity.error);
    }

    closeModal() {
        if (this.modalClosedCallback) {
            this.modalClosedCallback();
        }
    }


    login() {
        this.analytics.SendEventGa('selection', null, 'Logowanie_Wysłanie formularza', 0);
        this.isLoading = true;
        this.alertService.startLoadingMessage("", "Logowanie...");
        this.authService.login(this.userLogin.email, this.userLogin.password, this.userLogin.rememberMe)
            .subscribe(
            user => {
                setTimeout(() => {
                    this.alertService.stopLoadingMessage();
                    this.isLoading = false;

                    this.reset();
                    localStorage.setItem(SesaRegisterComponent.ALREADY_REGISTERED, "true");
                    if (!this.isModal) {
                        this.alertService.showMessage( `Witaj ${user.userName}!`,null , MessageSeverity.success);
                    }
                    else {
                        this.alertService.showMessage(`Witaj ponownie ${user.userName}!`,null, MessageSeverity.success);
                        setTimeout(() => {
                            this.alertService.showStickyMessage("Sesja odzyskana", "Spróbuje ponownie", MessageSeverity.default);
                        }, 500);

                        this.closeModal();
                    }
                }, 500);
            },
            error => {

                this.alertService.stopLoadingMessage();

                if (Utilities.checkNoNetwork(error)) {
                    this.alertService.showStickyMessage("Nieudane logowanie", "Problem techniczny, spróbuj ponownie za chwilę", MessageSeverity.error, error);
                }
                else {
                    let errorMessage = Utilities.findHttpResponseMessage("error_description", error);

                    if (errorMessage)
                        this.alertService.showStickyMessage("Nieudane logowanie", errorMessage, MessageSeverity.error, error);
                    else
                        this.alertService.showStickyMessage("Nieudane logowanie", "Wystąpił błąd logowania spróbuj ponownie za chwilę", MessageSeverity.error, error);
                }

                setTimeout(() => {
                    this.isLoading = false;
                }, 500);
            });
    }


    offerAlternateHost() {

        if (Utilities.checkIsLocalHost(location.origin) && Utilities.checkIsLocalHost(this.configurations.baseUrl)) {
            this.alertService.showDialog("Dear Developer!\nIt appears your backend Web API service is not running...\n" +
                "Would you want to temporarily switch to the online Demo API below?(Or specify another)",
                DialogType.prompt,
                (value: string) => {
                    this.configurations.baseUrl = value;
                    this.alertService.showStickyMessage("API Changed!", "The target Web API has been changed to: " + value, MessageSeverity.warn);
                },
                null,
                null,
                null,
                this.configurations.fallbackBaseUrl);
        }
    }


    reset() {
        this.formResetToggle = false;

        setTimeout(() => {
            this.formResetToggle = true;
        });
        this.orderService.saveLocalProjectsOnUserAccount();
        this.orderService.clearContext();
        this.orderService.loadMyProjectsFromDB();
        //this.orderService.mergeLocalWithDb();
    }
    signUp() {
        this.analytics.SendEventGa('selection', null, 'Logowanie_Przejście to rejesracji', 0);
        let cameFromSesaRegistration = new Boolean(localStorage.getItem(SesaRegisterComponent.SESA_RECENT_VIEWER));
        console.log('cameFromSesaRegistration: ' + cameFromSesaRegistration);
        if (cameFromSesaRegistration != null && cameFromSesaRegistration == true )
            this.router.navigateByUrl('/se');
        else
            this.router.navigateByUrl('/rejestracja');
    }
    resetPass() {
        this.analytics.SendEventGa('selection', null, 'Logowanie_Przejście to resetu hasła', 0);
        this.router.navigateByUrl('/odzyskaj-konto');
    }

}
